export default __webpack_public_path__ + "static/media/kids.e9e3c791.png";